import {
    GET_HOMES,
    GET_HOME,
    ADD_HOME,
    DELETE_HOME,
    UPDATE_HOME,
    HOME_ERROR,
} from '../types'

const homeReducer = (state, action) => {
    switch (action.type) {
        case GET_HOMES:
            return {
                ...state,
                homes: action.payload,
            }
        case GET_HOME:
            return {
                ...state,
                currentHome: action.payload,
            }
        case ADD_HOME:
            return {
                ...state,
                homes: [...state.homes, action.payload],
            }
        case DELETE_HOME:
            return {
                ...state,
                homes: state.homes.filter(
                    (home) => home._id !== action.payload._id
                ),
            }
        case UPDATE_HOME:
            return {
                ...state,
                homes: state.homes.map((home) =>
                    home._id === action.payload._id ? action.payload : home
                ),
            }
        case HOME_ERROR:
            return {
                ...state,
                error: action.payload,
            }
        default:
            return state
    }
}

export default homeReducer;